<template>
  <div class="Drops-filters">
    <AlgoliaCurrentFilters />
    <!-- <AlgoliaDateFilter
      v-for="(dateFilter, index) in dateFilters"
      :key="index"
      :index="index"
      :dateFilter="dateFilter"
    /> -->
    <AlgoliaSelectableFilters :arrFilters="arrFilters" />
  </div>
</template>

<script>
import AlgoliaSelectableFilters from '@/components/general/AlgoliaSelectableFilters'
import AlgoliaDateFilter from '@/components/general/AlgoliaDateFilter2'
import AlgoliaCurrentFilters from '@/components/general/AlgoliaCurrentFilters'

export default {
  name: 'BacklogAlgoliaFilters',
  components: {
    AlgoliaSelectableFilters,
    AlgoliaDateFilter,
    AlgoliaCurrentFilters
  },
  props: {},
  data () {
    return {}
  },
  computed: {
    // dateFilters () {
    //   return [
    //     { title: this.$i18n.t('shipments.departure'), attribute: 'pickupLocal.from' },
    //     { title: this.$i18n.t('shipments.arrival'), attribute: 'deliveryLocal.from' }
    //   ]
    // },
    arrFilters () {
      return [
        { title: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.seller'), attribute: 'origin.name' },
        { title: this.$i18n.tc('companies.companies', 2) + ' - ' + this.$i18n.t('orders.buyer'), attribute: 'destination.name' },
        { title: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.origin'), attribute: 'origin.address' },
        { title: this.$i18n.t('locations.address') + ' - ' + this.$i18n.t('orders.destination'), attribute: 'destination.address' },
        { title: this.$i18n.t('shipments.status'), attribute: 'status', i18nPreffix: 'drops.' },
        { title: this.$i18n.t('drops.consolidation'), attribute: 'consolidation', i18nPreffix: 'drops.' }
        // { title: this.$i18n.t('drops.consolidation'), attribute: 'consolidation', i18nPreffix: 'drops.' }
      ]
    }
  },
  methods: {},
  created () {}
}
</script>

<style lang="scss" scoped>
</style>
